import { LOCALE_ID, Provider } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslationConfiguratorService } from './translation-configurator.service';

export class LocaleId extends String {
    static localesFromLanguages = {
        'pt': 'pt-BR',
        'en': 'en-US'
    };

    constructor(private translate: TranslateService) {
        super();
    }

    toString(): string {
        const lang = TranslationConfiguratorService.decideUseLanguage(this.translate.getBrowserLang());
        return LocaleId.localesFromLanguages[lang];
    }

    valueOf(): string {
        return this.toString();
    }
}

export const LocaleProvider: Provider = {
    provide: LOCALE_ID,
    useClass: LocaleId,
    deps: [TranslateService],
};



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/shared/services/locale.service.ts